<template>
    <div>
        <subcontractor-approval-modal ref="subcontractorApprovalModal"></subcontractor-approval-modal>

        <v-server-table ref="clientSubTable" url="/client-subcontractor-approvals" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <template v-if="assetType">
                    <b-button size="md" variant="success" v-on:click="generateApprovals()" title="Run Subcontractor Approval" :disabled="generatingApprovals">
                        <template v-if="generatingApprovals">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Calculating...
                        </template>
                        <template v-else>
                            <i class="fa fa-flask"></i> Re-Generate Approvals
                        </template>
                    </b-button>
                </template>
            </div>

            <router-link slot="sub_approval_id" slot-scope="props" :to="`/subcontractors/approval-history/${props.row.sub_approval_id}`" title="View Client">
                View History
            </router-link>

            <router-link slot="subcontractor_name" slot-scope="props" :to="`/subcontractors/view/${props.row.subcontractor_id}`" title="View Subcontractor">
                {{ props.row.subcontractor_name }}
            </router-link>

            <template slot="sub_status_name" slot-scope="props">
                <span :class="`badge badge-${props.row.sub_status_color}`">{{ props.row.sub_status_name }}</span>
            </template>

            <router-link slot="client_name" slot-scope="props" :to="`/clients/view/${props.row.client_id}`" title="View Client">
                {{ props.row.client_name }}
            </router-link>

            <template slot="approval_status_name" slot-scope="props">
                <template v-if="props.row.approval_status_name">
                    <span :class="`badge badge-${props.row.approval_status_color}`">{{ props.row.approval_status_name }}</span>
                </template>
                <template v-else>
                    <span class="badge badge-secondary">N/A</span>
                </template>
                - <a href="javascript:void(0)" v-on:click="viewSubApprovalResults((props.row.client_metrics), props.row)" title="View Subcontractor Approval Results">View Results</a>
            </template>

            <template slot="approval_created_at" slot-scope="props">
                {{ props.row.approval_created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>
            <template slot="sub_last_updated_at" slot-scope="props">
                {{ props.row.sub_last_updated_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>
        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: ['assetType', 'assetId', 'columns'],

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                generatingApprovals: false,
                options: {
                    columnsDropdown: false,
                    headings: {
                        sub_approval_id: 'View History',
                        subcontractor_name: 'Subcontractor',
                        sub_status_name: 'Pre-Qualification Status',
                        client_name: 'Client',
                        approval_status_name: 'Client Approval Status',
                        approval_created_at: 'Approval Generated At',
                        sub_last_updated_at: 'Subcontractor Last Updated',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'subcontractors.subcontractor_name',
                    },
                    requestAdapter: (data) => {
                        //How do we get the filters
                        //data.filters = this.$store.state.tableFilters.subcontractorFilters;

                        //INclude the asset
                        data.assetType = this.assetType;
                        data.assetId = this.assetId;

                        //Send it
                        return data;
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        if(response.data.count > 0)
                        {
                            //Send it
                            this.$emit('firstClientSubApproval', response.data.data[0]);
                        }

                        //Emit the Total Count
                        this.$emit('totalClientApprovals', response.data.count);

                        //Send it
                        return response.data;
                    },
                    uniqueKey: 'sub_approval_id',
                },
            }
        },

        computed: {},

        methods: {

            viewSubApprovalResults(approvalResults, data){
                //Set the {}}
                this.$refs.subcontractorApprovalModal.setModel(approvalResults, data);

                //Activate the modal
                this.$refs.subcontractorApprovalModal.showModal();
            },

            generateApprovals(){
                //Saving
                this.generatingApprovals = true;

                //Send it
                this.$http
                .post('client-subcontractor-approvals', {assetType: this.assetType, assetId: this.assetId})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Approval Calculations Complete');

                    //Redraw the Table
                    this.$refs.clientSubTable.refresh();
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.generatingApprovals = false;
                });
            }
        },

        mounted() {

        }
    }
</script>